"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ShopClickOrigin=void 0;var r;(function(e){e.HomeSearch="home_search",e.Search="search",e.ShopList="shop_list"})(r||(exports.ShopClickOrigin=r={}));
//# sourceMappingURL=ShopClickOrigin.js.map
